'use client';

import { useMemo } from 'react';
import { useActiveSection } from './useActiveSection';
import type { MenuCategory } from '@/lib/types';

/**
 * Categories pin alongside the menu and track whichever section is in view.
 * On phones this becomes a horizontally scrollable row of chips.
 */
export function CategoryRail({ categories }: { categories: readonly MenuCategory[] }) {
  const ids = useMemo(() => categories.map((category) => category.id), [categories]);
  const active = useActiveSection(ids);

  return (
    <div className="sticky top-0 z-10 flex gap-6 overflow-x-auto border-b border-ink/20 bg-paper px-6 py-4 md:flex-col md:gap-3 md:overflow-visible md:border-b-0 md:border-r md:px-0 md:py-9">
      {categories.map((category) => (
        <a
          key={category.id}
          href={`#${category.id}`}
          aria-current={active === category.id ? 'true' : undefined}
          className={`label-xs whitespace-nowrap transition-colors md:px-7 ${
            active === category.id ? 'text-brick' : 'text-ink-soft hover:text-ink'
          }`}
        >
          {category.name}
        </a>
      ))}
    </div>
  );
}
